import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import Table from '../../components/Listing/Table';
import Button from '../../components/Form/Button';
import { usePageTitle } from '../../layouts/PageTitleContext';
import { API_BASE_URL } from '../../api';

export default function BackofficeNewsletterSubscribers() {
    const { setTitle, setTitleIcon, setTitleDescription } = usePageTitle();
    const [subscribers, setSubscribers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');

    const load = useCallback(() => {
        setLoading(true);
        return axios.get(`${API_BASE_URL}/api/v1/backoffice/newsletter-subscribers`, { withCredentials: true })
            .then(({ data }) => setSubscribers(data))
            .catch(() => toast.error('Impossible de charger les abonnés.'))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        document.title = 'Backoffice — Newsletter';
        load();
    }, [load]);

    useEffect(() => {
        setTitle('Newsletter');
        setTitleDescription('Abonnés inscrits depuis le formulaire du site public');
        setTitleIcon('ti-mail-opened');
        return () => { setTitleDescription(null); setTitleIcon(null); };
    }, [setTitle, setTitleDescription, setTitleIcon]);

    const handleDelete = (row) => {
        axios.delete(`${API_BASE_URL}/api/v1/backoffice/newsletter-subscribers/${row.id}`, { withCredentials: true })
            .then(() => {
                toast.success('Abonné supprimé.');
                load();
            })
            .catch(() => toast.error('Une erreur est survenue.'));
    };

    const columns = [
        { accessor: 'email', Header: 'Email', sortable: true },
        {
            accessor: 'createdAt',
            Header: 'Inscrit le',
            sortable: true,
            Cell: row => new Date(row.createdAt).toLocaleString('fr-FR'),
        },
        {
            accessor: 'actions',
            Header: '',
            className: 'col-actions',
            Cell: row => (
                <div className="cell-dropdown">
                    <button className="cell-actions-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <FontAwesomeIcon icon={faEllipsisH} />
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                            <Button
                                className="dropdown-item text-danger"
                                onConfirm={() => handleDelete(row)}
                            >
                                Supprimer
                            </Button>
                        </li>
                    </ul>
                </div>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            data={subscribers}
            mode="client"
            loading={loading}
            keyword={keyword}
            setKeyword={setKeyword}
            searchPlaceholder="Rechercher un email..."
            rowId="id"
            pageSize={20}
            emptyMessage="Aucun abonné à la newsletter"
        />
    );
}
